module.exports = __webpack_public_path__ + "static/media/privacypolicy.c2ee838d.htm";